module.exports = __webpack_public_path__ + "static/Whole-Foods-7977bab3b63ea17b270ae65921ad5531.png";